// API Version and Base Path Configuration
export const API_VERSION = "v1";
export const API_BASE_PATH = `/api/${API_VERSION}`;

// API Endpoint Paths (without base prefix)
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    ME: "/auth/me",
    VALIDATE: "/auth/validate",
    PASSWORD: "/auth/password",
    VERIFY_RESET_TOKEN: "/auth/verify-reset-token",
    RESET_PASSWORD: "/auth/reset-password",
    REQUEST_PASSWORD_RESET: "/auth/request-password-reset",
    REGISTER_DEMO: "/auth/register-demo",
  },

  // Admin endpoints
  ADMIN: {
    STATS: "/admin/stats",
    USERS: "/admin/users",
    USER_ACTIVITY_SUMMARY: "/admin/users/activity-summary",
    CREATE_USER: "/admin/users",
    INVITE_USER: "/admin/users/invite",
    COMPANIES: "/admin/companies",
    AUDIT_LOGS: "/admin/audit-logs",
    HEALTH: "/admin/health",
  },

  // Search endpoints
  SEARCH: {
    SEARCH: "/search",
    HISTORY: "/search-history",
  },

  // Other endpoints
  PROMPTS: "/prompts",
  ANALYTICS: "/analytics",
  TOKEN_USAGE: "/token-usage",
  WS: "/ws",
};

// Helper function to build full API path
export const buildApiPath = (endpoint) => {
  if (endpoint.startsWith(API_BASE_PATH)) {
    return endpoint;
  }
  return `${API_BASE_PATH}${endpoint}`;
};

// Centralized API configuration
export const getApiUrl = () => {
  return (
    process.env.REACT_APP_API_URL ||
    `${window.location.protocol}//${window.location.hostname}:8000`
  );
};
